<div class="search-container mb-2">
  <div class="input-wrapper">
    <input
      #searchInput
      type="text"
      class="form-control"
      placeholder="{{ 'shared-components.icd-code' | translate }}"
      [(ngModel)]="searchQuery"
      (focus)="showResults = true"
    />
    <button
      *ngIf="searchQuery"
      class="clear-button"
      (click)="clearSearch($event)"
    >
      <i class="fa fa-close"></i>
    </button>
  </div>

  <div *ngIf="showResults" class="results-container" #resultsContainer>
    <div *ngIf="filteredResults.length === 0" class="no-results">
      {{ "common.noData" | translate }}
    </div>

    <div
      *ngFor="let result of filteredResults"
      class="result-item"
      (click)="selectItem(result)" role="button"  tabindex="-1"
    >
      {{ result.label }}
    </div>

    <div *ngIf="totalResults > 100" class="more-results">
      {{ totalResults }} {{ "common.showing-first-1" | translate }} 100
      {{ "common.showing-first-2" | translate }}
    </div>
  </div>
</div>
